import React, { useEffect, useState } from 'react';
import { PrimeIcons } from 'primereact/api';

/** Pins the save action above the mobile tab bar; desktop keeps it in-flow. */
export const StickySaveBar = ({ children }: { children: React.ReactNode }) => {
  const [scrollable, setScrollable] = useState(false);
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    const update = () => {
      const root = document.documentElement;
      setScrollable(root.scrollHeight > window.innerHeight + 8);
      setAtTop(window.scrollY < 24);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    const observer = new ResizeObserver(update);
    observer.observe(document.body);

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      observer.disconnect();
    };
  }, []);

  const jump = () => {
    window.scrollTo({
      top: atTop ? document.documentElement.scrollHeight : 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div className="h-[72px] lg:hidden shrink-0" aria-hidden="true" />
      <div className="fixed z-40 w-full px-[16px] py-[12px] bg-[#F5F7F9]/95 backdrop-blur-sm border-t border-[#EAECEF] left-0 right-0 md:left-[272px] bottom-[calc(var(--app-tabbar-h)+env(safe-area-inset-bottom))] lg:static lg:z-auto lg:left-auto lg:right-auto lg:bottom-auto lg:w-[608px] lg:px-0 lg:py-0 lg:bg-transparent lg:border-0 lg:backdrop-blur-none">
        {scrollable && (
          <button
            type="button"
            onClick={jump}
            aria-label={atTop ? 'Scroll down' : 'Scroll to top'}
            className="lg:hidden absolute left-1/2 -translate-x-1/2 bottom-[calc(100%+2px)] h-[36px] w-[36px] rounded-full bg-[#FF6F61] flex items-center justify-center text-white transition-opacity hover:opacity-85 active:opacity-70"
          >
            <i
              className={atTop ? PrimeIcons.CHEVRON_DOWN : PrimeIcons.CHEVRON_UP}
              style={{ fontSize: '0.85rem' }}
              aria-hidden="true"
            />
          </button>
        )}
        {children}
      </div>
    </>
  );
};
